import {PaymentCard} from 'coreStore/data/orders/types';

/**
 * Represents an order payment card
 */
class PaymentCardModel {
	private readonly paymentCard: PaymentCard;

	/**
	 * @constructor
	 * @param {PaymentCard} paymentCard - payment card
	 */
	constructor(paymentCard) {
		this.paymentCard = paymentCard;
	}

	/**
	 * Returns payment card type
	 * @returns {number} holder
	 */
	getCardType() {
		return this.paymentCard.cardType;
	}

	/**
	 * Returns payment card holder
	 * @returns {number} holder
	 */
	getHolder() {
		return this.paymentCard.holder;
	}

	/**
	 * Returns payment card masked number
	 * @returns {number} masked number
	 */
	getMaskedNumber() {
		return this.paymentCard.maskedNumber;
	}

	/**
	 * Returns payment card expiration month
	 * @returns {number} masked expiration month
	 */
	getExpirationMonth() {
		return this.paymentCard.expirationMonth;
	}

	/**
	 * Returns payment card expiration year
	 * @returns {number} masked expiration year
	 */
	getExpirationYear() {
		return this.paymentCard.expirationYear;
	}
}

export default PaymentCardModel;
